import classNames from 'classnames';
import ProductSortSelection from 'components/ProductSortSelection';
import styles from './ProductSortController.module.scss';

export default function ProductSortController({
  categoryFiltersEnabled,
  promotion,
  sortOptions,
}) {
  return (
    <div
      className={classNames('d-flex flex-row w-md-auto', {
        'w-50 ms-4 ms-md-0': categoryFiltersEnabled,
        'w-100': !categoryFiltersEnabled,
      })}
    >
      <div
        className={classNames(
          'mt-4 me-10 font-roboto text-grey-darker',
          styles.label
        )}
      >
        Sort By
      </div>
      <div
        className={`${styles.selectorWidth}`}
        data-value="category-page-sort-dropdown"
      >
        <ProductSortSelection promotion={promotion} sortOptions={sortOptions} />
      </div>
    </div>
  );
}
